module.exports = {
          srcSet: __webpack_public_path__ + "732f1e9c45a5393318d72b4d019e5fb5-800.png"+" 800w",
          images:[ {path: __webpack_public_path__ + "732f1e9c45a5393318d72b4d019e5fb5-800.png",width: 800,height: 563}],
          src: __webpack_public_path__ + "732f1e9c45a5393318d72b4d019e5fb5-800.png",
          toString:function(){return __webpack_public_path__ + "732f1e9c45a5393318d72b4d019e5fb5-800.png"},
          
          width: 800,
          height: 563
        }